export const ERROR_TYPE_TIMEOUT = 'wlproxy-timeout-error';
export const ERROR_TYPE_TASK_FAILURE = 'wlproxy-task-failure-error';
export const ERROR_TYPE_IMMEDIATE = 'wlproxy-immediate-error';
